exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".type-label[data-v-3494ba4e]{color:var(--wf-primary);display:block;font-weight:400;font-size:1em;text-transform:uppercase}h1[data-v-3494ba4e]{font-size:22px}.group-title-wrapper[data-v-3494ba4e]{width:100%}h1.edit-d-title[data-v-3494ba4e]:after{background:transparent;right:-40px}textarea.title-field[data-v-3494ba4e]{font-size:22px}", ""]);

// exports
